import { memo } from "react";
const Header = ({ title = "", children, ...props }) => {
  const today = new Date().toLocaleDateString("es-GT", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return (
    <>
      <div className="mb-5 flex justify-between border border-secundarioMira border-b-grisMira flex-wrap gap-2">
        <div className="flex content-center mt-4 lg:mb-4">
          {props.logo ? (
            <props.logo className="h-11 w-11 mr-2 text-secundario" />
          ) : null}
          <h1 className="my-auto text-2xl font-semibold text-white">{title}</h1>
        </div>
        {children ? (
          children
        ) : (
          <div className="lg:mb-2 lg:mt-2 py-1 px-1 rounded-lg flex place-content-center">
            <p className="my-auto text-white text-xl font-semibold">{today}</p>
          </div>
        )}
      </div>
    </>
  );
};

export default memo(Header);
